import React, { useState, useEffect } from 'react';
import './Preloader.css';

const Preloader = ({ children, imageUrls = [] }) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // لو مفيش صور في القائمة، نلغي شاشة التحميل فوراً
    if (!imageUrls || imageUrls.length === 0) {
      setLoading(false);
      return;
    }

    let loadedCount = 0;
    const totalImages = imageUrls.length;

    const handleImageLoad = () => {
      loadedCount++;
      const currentProgress = Math.floor((loadedCount / totalImages) * 100);
      setProgress(currentProgress);

      if (loadedCount === totalImages) {
        // وقت بسيط ناعم قبل الاختفاء
        setTimeout(() => {
          setLoading(false);
        }, 400);
      }
    };

    // تحميل كائن الصورة في الخفاء
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.onload = handleImageLoad;
      img.onerror = handleImageLoad; // حتى لو صورة حصل فيها مشكلة ما نعطلش الموقع
    });

    // حماية: لو في صور طوّلت أوي على الشبكة، الموقع يفتح تلقائياً بعد 6 ثواني كحد أقصى
    const maxTimeout = setTimeout(() => {
      setLoading(false);
    }, 6000);

    return () => clearTimeout(maxTimeout);
  }, [imageUrls]);

  return (
    <>
      {loading && (
        <div className="preloader-overlay">
          <div className="preloader-content text-center">
            {/* مؤشر التحميل الدائري الفاخر */}
            <div className="preloader-spinner mb-3"></div>

            {/* شريط النسبة المئوية */}
            
          </div>
        </div>
      )}

      {/* المحتوى الأصلي للموقع بيظهر ناعم أول ما يخلص */}
      <div className={`site-content ${!loading ? 'loaded' : ''}`}>
        {children}
      </div>
    </>
  );
};

export default Preloader;